import { LandingContent } from "./types";

export const leadGenerationLanding: LandingContent = {
  ctaText: "Schedule a growth call",
  quickFacts: ["No setup fees", "No contracts", "Performance based"],
  whyHeading: "Why teams use Lead Generation",
  why: "Lead Generation has been the #1 customer-acquisition engine for CertainPath members for over 15 years. We combine key demographic data points to identify the homeowners most likely to need your services, then design, print, and mail compelling postcards on your behalf. Match-back reporting connects every dollar of revenue back to the households that received your mailer — no more guessing what works.",
  advantages: [
    {
      title: "Demographic targeting",
      description:
        "Home value, age, income, dwelling age, and ownership filters isolate the 20% of households driving 80% of revenue.",
      includedNote: "Target only high-value homeowners",
    },
    {
      title: "Design & print included",
      description:
        "Our creative team produces postcard variants tested across hundreds of markets — you approve, we ship.",
      includedNote: "Match-back reporting proves ROI",
    },
    {
      title: "Match-back reporting",
      description:
        "We join your invoice data to the mail list and report exact revenue attribution down to the household.",
      includedNote: "No contracts, cancel anytime",
    },
  ],
  featureChecklist: [
    "Target only high-value homeowners",
    "Match-back reporting proves ROI",
    "No contracts, cancel anytime",
    "Fully done-for-you service",
  ],
  highlights: [
    {
      title: "Multi-touch sequences",
      description:
        "Prospect, winback, and seasonal campaigns orchestrated across the year to keep your schedule full.",
    },
  ],
  steps: [
    {
      title: "We build your audience",
      description:
        "Using 200+ data points, we identify homeowners most likely to need your services in your service area.",
    },
    {
      title: "Targeted mailings",
      description:
        "Premium postcards reach high-value prospects every 6 weeks — fully designed, printed, and shipped.",
    },
    {
      title: "Track new customers",
      description:
        "Match-back reporting shows exactly which new customers came from the mailings — every dollar attributed.",
    },
    {
      title: "Continuous optimization",
      description:
        "Your success manager refines targeting based on which demographics are converting best for you.",
    },
  ],
  testimonials: [
    {
      quote:
        "We've tried everything — Facebook ads, Google PPC, shared mailers. Nothing has given us the consistent ROI that this program provides. It's now our #1 lead source.",
      initials: "MT",
      name: "Mike Thompson",
      attribution: "Apex Plumbing · Denver, CO",
      stats: [
        { label: "Revenue", value: "$124k" },
        { label: "ROI", value: "12:1" },
      ],
    },
    {
      quote:
        "The ability to target only the homeowners we want is a game changer. We're not wasting money on renters or people who can't afford our services.",
      initials: "SL",
      name: "Sarah Lewis",
      attribution: "Comfort Air HVAC · Phoenix, AZ",
      stats: [
        { label: "Revenue", value: "$89k" },
        { label: "ROI", value: "15:1" },
      ],
    },
    {
      quote:
        "I was skeptical at first, but the match-back reports proved it works. Seeing exactly which customers called from the postcards gave me total confidence.",
      initials: "DR",
      name: "David Rodriguez",
      attribution: "Rooter Pro · Chicago, IL",
      stats: [
        { label: "Revenue", value: "$210k" },
        { label: "ROI", value: "18:1" },
      ],
    },
  ],
  faqs: [
    {
      question: "How quickly can we get started?",
      answer:
        "Most contractors are up and running within 2 weeks. We handle targeting, data selection, design, and printing for you.",
    },
    {
      question: "How do you find the right prospects?",
      answer:
        "Home value, age, income, dwelling age, and ownership filters identify the homeowners most likely to need your services. No more spray-and-pray.",
    },
    {
      question: "How is performance tracked?",
      answer:
        "Match-back reporting connects new customer revenue directly to mail recipients. You'll see exactly which prospects became customers and how much they spent.",
    },
    {
      question: "What response rate can I expect?",
      answer:
        "Prospect mailings typically see 0.5–2% response rates depending on your offer, service type, and market. Targeting is continuously optimized to improve over time.",
    },
    {
      question: "Are there long-term contracts?",
      answer:
        "No contracts required. We're confident in our results, so you can cancel anytime if you're not satisfied.",
    },
  ],
  closing: {
    heading: "Ready to grow your customer base?",
    body: "Get a free market analysis showing how many new customers are waiting in your service area.",
  },
};
